<template>
  <div class="layout-frame">
    <div class="container">
      <div class="mx-auto max-w-96">
        <h1 class="mb-6 flex items-center text-white text-2xl font-bold">
          {{ t('profile.title') }}<Loader2 v-if="isFanFetching" class="ml-2 h-4 w-4 animate-spin" />
        </h1>
        <UserDetailsForm
          :initialValues="fanData"
          emailDisabled
          canChangeEmail
          :collectFields="collectFields"
          :requiredRules="requiredRules"
          :submitButtonText="isSubmitting ? t('common.saving') : t('common.save')"
          :error="fanPatchError?.message"
          :success="fanPatchData ? t('profile.success') : undefined"
          :isSubmitting="isSubmitting"
          :isLoading="isFanFetching"
          @submit="onSubmit"
          @change="resetErrorAndSuccess"
          @clearError="resetErrorAndSuccess"
          @clearSuccess="resetErrorAndSuccess"
        >
        </UserDetailsForm>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFanStore } from '@stores/fan.store';
import { type UserDetails } from '@modules/UserDetailsForm/UserDetails.interface';
import UserDetailsForm from '@modules/UserDetailsForm/UserDetailsForm.vue';
import { Loader2 } from 'lucide-vue-next';

const collectFields = {
  firstName: true,
  lastName: true,
  email: true,
  location: true,
  phoneNumber: true,
  birthDate: true,
  consentEmail: true,
  consentMessaging: true,
};

const requiredRules = {
  firstName: true,
  lastName: true,
  email: true,
  location: true,
  phoneNumber: true,
  birthDate: true,
  consentEmail: false,
  consentMessaging: false,
};

const { t } = useI18n();
const fanStore = useFanStore();
const { fanData, fanPatchData, fanPatchError, isFanFetching } = storeToRefs(fanStore);
const isSubmitting = ref(false);

const onSubmit = async (formData: UserDetails) => {
  fanPatchData.value = null;
  fanPatchError.value = null;
  isSubmitting.value = true;
  await fanStore.fanPatch(formData);
  isSubmitting.value = false;
};

const resetErrorAndSuccess = () => {
  fanPatchError.value = null;
  fanPatchData.value = null;
};

onMounted(() => {
  fanPatchData.value = null;
  fanPatchError.value = null;
});
</script>
